import React from 'react';
import { Card, CardBody } from '@heroui/react';
import { motion } from 'framer-motion';

interface StatCardProps {
  label: string;
  value: number | string;
  suffix?: string;
  delay?: number;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, suffix, delay = 0 }) => {
  return (
    <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.3, delay }}>
      <Card className="bg-default-50 dark:bg-default-100/10">
        <CardBody className="p-4 text-center">
          <p className="text-2xl font-bold text-foreground">
            {value}
            {suffix && <span className="text-lg text-default-500">{suffix}</span>}
          </p>
          <p className="text-xs text-default-500 mt-1">{label}</p>
        </CardBody>
      </Card>
    </motion.div>
  );
};

export default StatCard;

